import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./config/toast";
import "./config/sweetalert";
import "./config/vuelidate";
import "./config/geocoder";
import "./config/globalMixins";
import "./config/globalDirectives";
import "./config/globalFilters";
import * as VueGoogleMaps from "vue2-google-maps";
import { KeycloakUtils } from "./config/keycloak";

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC6pVhPeT8AmD4IZoyHh7aWoHfSOq9eBIQ"
  },
  installComponents: true
});

const initializeTokenRefresh = async () => {
  try {
    const hasKeycloakTokens =
      KeycloakUtils.getCookie("keycloak_token") &&
      KeycloakUtils.getCookie("keycloak_refresh_token");

    if (hasKeycloakTokens) {
      const initResult = await KeycloakUtils.initializeTokenCheck();

      if (initResult.expired) {
        store.dispatch("AUTH_LOGOUT");
        KeycloakUtils.clearAllTokens();
      } else if (initResult.initialized) {
        if (initResult.timeToExpiry) {
          const expiresInSeconds = Math.floor(initResult.timeToExpiry / 1000);
          KeycloakUtils.startTokenRefreshTimer(expiresInSeconds);
        }
      } else if (initResult.missingAuthTokens) {
        try {
          await KeycloakUtils.refreshToken();
        } catch (refreshError) {
          store.dispatch("AUTH_LOGOUT");
          KeycloakUtils.clearAllTokens();
        }
      }
    }
  } catch (error) {
    void error;
  }
};

new Vue({
  router,
  store,
  vuetify,
  created() {
    initializeTokenRefresh();
  },
  render: h => h(App)
}).$mount("#app");
